import React from 'react';
import {
  Box,
  Heading,
  SkeletonGroup,
  SkeletonRectangle,
} from '@wix/design-system';
import s from './horizontal-nav-bar-skeleton.module.scss';
import { horizontalNavBarDataHooks } from './data-hooks';

const pillsCount = 8;
const tabsCount = 3;

export function HorizontalNavBarSkeleton({
  skin = 'pills',
  title,
}: {
  skin?: 'pills' | 'tabs';
  title?: string;
}) {
  if (skin === 'tabs') {
    return <TabsSkeleton title={title} />;
  }
  return <PillsSkeleton />;
}

function TabsSkeleton({ title }: { title?: string }) {
  return (
    <SkeletonGroup skin="light" dataHook={horizontalNavBarDataHooks.skeleton}>
      <Box gap="24px" verticalAlign="middle">
        {title && (
          <Heading size="extraLarge" dataHook={horizontalNavBarDataHooks.title}>
            {title}
          </Heading>
        )}
        <Box gap="8px" verticalAlign="middle">
          {Array.from({ length: tabsCount }, (_, index) => (
            <Box key={index} className={s.tab}>
              <SkeletonRectangle width="80px" height="40px" />
            </Box>
          ))}
        </Box>
      </Box>
    </SkeletonGroup>
  );
}

function PillsSkeleton() {
  return (
    <SkeletonGroup skin="light" dataHook={horizontalNavBarDataHooks.skeleton}>
      <Box className={s.skeletonBar}>
        <Box className={s.pills}>
          {Array.from({ length: pillsCount }, (_, index) => (
            <Box key={index} className={s.tab}>
              <SkeletonRectangle width="100px" height="30px" />
            </Box>
          ))}
        </Box>
        <Box className={s.tab}>
          <SkeletonRectangle width="213px" height="30px" />
        </Box>
      </Box>
    </SkeletonGroup>
  );
}
